<template>
   <div class="role">
      <Delete :delete_message="delete_message" :show="show_delete_modal" @close="$store.commit('show_delete_modal',false)" @delete="deleteRole()"/>

      <Modal :show="show_create_modal" content_class="col-12 col-md-11 col-lg-10 col-xl-9" @close="$store.commit('show_create_modal',false)">
         <template slot="title">
            <div class="title">Roles</div>
            <div class="subtitle">Create roles and assign permissions</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="Role.forms.addRole.name" 
                  :forms="Role.forms.addRole.forms" 
                  :form_data="Role.forms.addRole.data"
               />
               <div class="accordion-section">
                  <div class="title">Permissions</div>
                  <div class="cust-accordion">
                     <div v-for="(group,i) in resourcesGroups" :key="i" class="item">
                        <div class="top clearfix" @click="openAccordion(i)">
                           <div class="txt-box l">
                              <div class="subtitle">{{group.name}}</div>
                           </div>
                           <div class="icon-box r">
                              <transition name="fade">
                                 <i v-if="activeAccordion !== i" class="fa fa-chevron-right"></i>
                                 <i v-if="activeAccordion === i" class="fa fa-chevron-down"></i>
                              </transition>
                           </div>
                        </div>
                        <transition name="fade">
                           <div class="bottom" v-if="activeAccordion == i">
                              <div class="accordion-content">
                                 <div class="title-box">
                                    <div class="row">
                                       <div class="col-lg-7">Resource</div>
                                       <div class="col-lg-1 center">Create</div>
                                       <div class="col-lg-1 center">Read</div>
                                       <div class="col-lg-1 center">Update</div>
                                       <div class="col-lg-1 center">Delete</div>
                                       <div class="col-lg-1 center">Verify</div>
                                    </div>
                                 </div>

                                 <div class="row" v-for="(resource,j) in group.resources" :key="j">
                                    <div class="col-lg-7 resource">{{resource.name}}</div>
                                    <div class="col-lg-1 center">
                                       <Checkbox
                                          :disabled="!resource.allowed_actions[0]"
                                          :name="resource.code+'_create'"
                                          v-model="currentSelection[resource.code]['create']"
                                       />
                                    </div>
                                    <div class="col-lg-1 center">
                                       <Checkbox
                                          :disabled="!resource.allowed_actions[1]"
                                          :name="resource.code+'_read'"
                                          v-model="currentSelection[resource.code]['read']"
                                       />
                                    </div>
                                    <div class="col-lg-1 center">
                                       <Checkbox
                                          :disabled="!resource.allowed_actions[2]"
                                          :name="resource.code+'_update'"
                                          v-model="currentSelection[resource.code]['update']"
                                       />
                                    </div>
                                    <div class="col-lg-1 center">
                                       <Checkbox
                                          :disabled="!resource.allowed_actions[3]"
                                          :name="resource.code+'_delete'"
                                          v-model="currentSelection[resource.code]['delete']"
                                       />
                                    </div>
                                    <div class="col-lg-1 center">
                                       <Checkbox
                                          :disabled="!resource.allowed_actions[4]"
                                          :name="resource.code+'_verify'"
                                          v-model="currentSelection[resource.code]['verify']"
                                       />
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </transition>
                     </div>
                  </div>
               </div>

               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="addRole({ref: $refs[Role.forms.addRole.name]})" :disabled="loading">
                     Create <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Modal :show="show_edit_modal" content_class="col-12 col-md-11 col-lg-10 col-xl-9" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">Roles</div>
            <div class="subtitle">Edit roles and permissions</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="Role.forms.editRole.name" 
                  :forms="Role.forms.editRole.forms" 
                  :form_data="Role.forms.editRole.data"
               />
               <div class="accordion-section">
                  <div class="title">Permissions</div>
                  <div class="cust-accordion">
                     <div v-for="(group,i) in resourcesGroups" :key="i" class="item">
                        <div class="top clearfix" @click="openAccordion(i)">
                           <div class="txt-box l">
                              <div class="subtitle">{{group.name}}</div>
                           </div>
                           <div class="icon-box r">
                              <transition name="fade">
                                 <i v-if="activeAccordion !== i" class="fa fa-chevron-right"></i>
                                 <i v-if="activeAccordion === i" class="fa fa-chevron-down"></i>
                              </transition>
                           </div>
                        </div>
                        <transition name="fade">
                           <div class="bottom" v-if="activeAccordion == i">
                              <div class="accordion-content">
                                 <div class="title-box">
                                    <div class="row">
                                       <div class="col-lg-7">Resource</div>
                                       <div class="col-lg-1 center">Create</div>
                                       <div class="col-lg-1 center">Read</div>
                                       <div class="col-lg-1 center">Update</div>
                                       <div class="col-lg-1 center">Delete</div>
                                       <div class="col-lg-1 center">Verify</div>
                                    </div>
                                 </div>

                                 <div class="row" v-for="(resource,j) in group.resources" :key="j">
                                    <div class="col-lg-7 resource">{{resource.name}}</div>
                                    <div class="col-lg-1 center">
                                       <Checkbox
                                          :disabled="!resource.allowed_actions[0]"
                                          :name="resource.code+'_create'"
                                          v-model="currentSelection[resource.code]['create']"
                                       />
                                    </div>
                                    <div class="col-lg-1 center">
                                       <Checkbox
                                          :disabled="!resource.allowed_actions[1]"
                                          :name="resource.code+'_read'"
                                          v-model="currentSelection[resource.code]['read']"
                                       />
                                    </div>
                                    <div class="col-lg-1 center">
                                       <Checkbox
                                          :disabled="!resource.allowed_actions[2]"
                                          :name="resource.code+'_update'"
                                          v-model="currentSelection[resource.code]['update']"
                                       />
                                    </div>
                                    <div class="col-lg-1 center">
                                       <Checkbox
                                          :disabled="!resource.allowed_actions[3]"
                                          :name="resource.code+'_delete'"
                                          v-model="currentSelection[resource.code]['delete']"
                                       />
                                    </div>
                                    <div class="col-lg-1 center">
                                       <Checkbox
                                          :disabled="!resource.allowed_actions[4]"
                                          :name="resource.code+'_verify'"
                                          v-model="currentSelection[resource.code]['verify']"
                                       />
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </transition>
                     </div>
                  </div>
               </div>

               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="editRole({ref: $refs[Role.forms.editRole.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <div class="top-actions clearfix">
         <div class="btn btn-primary btn-r" @click="openCreateModal">
            Add Roles <i class="fa fa-plus"></i>
         </div>
      </div>

      <Table v-bind="Role.tables.roles.props" :data="roles" @on-action="handleActions"/>
   </div>
</template>

<script>
import role from "./role.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('role')
      Event.$off('form:submit_update');
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('role',role,this.$store)
   },
   data(){
      return{
         selection: {}
      }
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Checkbox: () => import("clarks/components/checkbox"),
      Table: () => import("clarks/components/ivu-table"),
   },
   computed: {
      ...mapGetters([
         'Role',
         'roles',
         'resourcesGroups',
         'show_create_modal',
         'show_edit_modal',
         'loading',
         'delete_message',
         'show_delete_modal',
         'activeAccordion',
         'currentSelection',
      ]),
   },
   methods: {
      ...mapActions([
         'fetchFormData',
         'fetchData',
         'addRole',
         'editRole',
         'updateRole',
         'handleActions',
         'deleteRole',
         'openAccordion',
         'openCreateModal',
      ]),
   },
   async mounted(){
      utils.registerModule('role',role,this.$store)
      await this.fetchData()
      this.selection = this.currentSelection
   }
}
</script>

<style lang="scss">
   .role{
      .accordion-section{
         padding: 10px 15px;

         .resource{
            // font-weight: 600;
            text-transform: uppercase;
         }
         .cust-accordion{
            .title-box{
               background: $table-border-color;
               padding: 9px 0;
               margin: 10px 0 10px 0;
               font-weight: 600;
               text-transform: uppercase;
            }
         }
         .center{
            text-align: center;
         }
      }
   }
</style>